/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DynamoDbBackupConfigApplication {
  /**
  * The read capacity units required for the table scan
  */
  'readCapacityUnitsRequired': number;
  /**
  * Whether autoscale is enabled for the table
  */
  'isAutoscaleEnabled': boolean;
  /**
  * The maximum read capacity units available for the table (if applied)
  */
  'maxReadCapacityUnits'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "readCapacityUnitsRequired",
      "baseName": "readCapacityUnitsRequired",
      "type": "number",
      "format": ""
    },
    {
      "name": "isAutoscaleEnabled",
      "baseName": "isAutoscaleEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "maxReadCapacityUnits",
      "baseName": "maxReadCapacityUnits",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamoDbBackupConfigApplication.attributeTypeMap;
  }

  public constructor() {
  }
}

